export type ConversationStartersContext =
  | { type: 'recruitment_general' }
  | {
      type: 'recruitment_candidate';
      params: { candidateId: number; candidateName: string };
    }
  | {
      type: 'recruitment_job';
      params: { jobId: number; jobTitle: string };
    }
  | {
      type: 'recruitment_analytics';
      params: { dashboardId: number; dashboardName: string };
    };

export interface ConversationStarterMessage {
  role: 'system' | 'user';
  content: string;
}

export interface ConversationStarter {
  id: string;
  source: string;
  definitionKey: string;
  skill: string | null;
  text: string;
  messages: readonly ConversationStarterMessage[];
  priority: number;
}

export interface ConversationStarters {
  type: ConversationStartersContext['type'];
  prompt: string;
  conversationStarters: readonly ConversationStarter[];
}

export const conversationStartersKey = (ctx: ConversationStartersContext): string => {
  switch (ctx.type) {
    case 'recruitment_candidate':
      return `${ctx.type}:${ctx.params.candidateId}`;
    case 'recruitment_job':
      return `${ctx.type}:${ctx.params.jobId}`;
    case 'recruitment_analytics':
      return `${ctx.type}:${ctx.params.dashboardId}`;
    default:
      return ctx.type;
  }
};
